import { AdminApi } from 'stylemix-vue-admin'

export default class CommissionsApiList extends AdminApi {
  constructor(parameters) {
    super('companies/my-commissions', parameters)
  }

  process(ids, company_id, param, config = {}) {
    return this.submit(
      'post',
      `/company/commissions/process`,
      { ids: ids || [], company_id },
      config,
    )
  }
}
